<template>
  <list-layout :tableTools='toggleTableTools'>
    <template slot='header'>
      <BaseHeader :content='header' />
    </template>
    <template slot='table-core'>
      <base-table-pagination :total='pagination.total' :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize' @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot='table-tags'>
      <base-table-filter-tags :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler"
        @saveTags="saveTagsHandler" />
    </template>
    <template slot='table-component'>
      <kendo-grid-component :spanish="spanish" :dataResult='kendo.dataResult' :kendo="kendo"
        :loading='isGeneralLoading' :selectedField="selectedField" @datastatechange='dataStateChange'
        @columnreorder='columnReorder' @rowclick='openPath' @columnssubmit='onColumnsSubmit' @sortchange='sortChange'
        @filterchange='filterChange' @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot='layout-extend'>
      <base-footer>
        <template slot='actions'>
          <div class='mt-5 mb-5'></div>
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel'
            :loading="isGeneralLoading || loader" :disabled="loader" />
        </template>
      </base-footer>
      <base-table-select-actions-expand :baseDropDownVisible="isMoreActionsVisible" :visibility="hasSelected"
        :selected="rowsSelected" :total="rowsTotal">
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesGeneral" :key="action.IdAccion">
            <base-button-item-list v-if="showAction(action)" theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" />
              <div class="w-72 text-left">
                {{ action.Descripcion }}
              </div>
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <Dialog :title="$t('invoices.send_invoice')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { downloadHandler(); showModal = false }" />
          </div>
        </template>
      </Dialog>
      <Dialog :title="$t('invoices.delete_invoice')" :visible.sync="showModalDelete" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { deleteHandler(); showModalDelete = false }" />
          </div>
        </template>
      </Dialog>
      <Dialog :title="$t('groups.unlink_groups')" :visible.sync="showModalUnlinkGroups" width="40%" custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkGroups
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalUnlinkGroups = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"
              @click="() => { unlinkGroupsHandler(); showModalUnlinkGroups = false }" />
          </div>
        </template>
      </Dialog>
      <invoice-link-groups-dialog :dialogOpen="showModalLinkGroups" multiple :idFacturae="firstIdFacturae"
        :idInvoice="firstIdInvoice" @toggleDialog="showModalLinkGroups = false"
        @applyDialog="(grupos) => { applyLinkHandler(grupos); showModalLinkGroups = false }" />
      <invoice-link-groups-dialog :dialogOpen="showModalLinkGroupsReasig" :idFacturae="firstIdFacturae"
        :idInvoice="firstIdInvoice" @toggleDialog="showModalLinkGroupsReasig = false"
        @applyDialog="(grupos) => { applyLinkReasignHandler(grupos); showModalLinkGroupsReasig = false }" />
      <filter-panel :panelOpen='filterPanel' @togglePanel='toggleFilters' @applyFilters='applyFiltersHandler'
        :status="status" />
      <create-search-dialog :numberSearches="numberSearches" :idVista="idVista" :dialogOpen="saveSearchDialog"
        :tags="tags" @toggleDialog="toggleDialogSearches" @applyDialog="applySearchHandler" />
      <filter-panel-searches ref="filterPanelSearches" :idVista="idVista" :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel" @togglePanel="toggleSearchesDialog" @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches" />
      <reject-invoice-dialog :dialogOpen="rejectDialog" @toggleDialog="toggleRejectDialog"
        @applyDialog="applyRejectDialog" />
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
import setNestedValue from '@/services/functions/setNestedValue'
import hasNestedValue from '@/services/functions/hasNestedValue'
import { load } from '@progress/kendo-vue-intl'
import { Dialog } from 'element-ui'
import { bus } from '@/main'

import KendoGridComponent from '@/components/KendoGridComponent.vue'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/received/InvoicesFilter.vue'
import InvoiceLinkGroupsDialog from '@/components/InvoiceLinkGroupsDialog.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import RejectInvoiceDialog from '@/components/RejectInvoiceDialog.vue'

import { getInvoices } from '@/services/invoices/getInvoices'
import { getInvoicesExcel } from '@/services/invoices/getInvoicesExcel'
import { linkInvoicesGroupReasign } from '@/services/configurations/groups/linkInvoicesGroupReasign'
import { linkInvoiceGroupsMultiple } from '@/services/configurations/groups/linkInvoiceGroupsMultiple'
import { unlinkInvoiceGroupsMultiple } from '@/services/configurations/groups/unlinkInvoiceGroupsMultiple'
import { actualizarEstadoAccion } from '@/services/invoices/actualizarEstadoAccion'

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
// import moment from 'moment'

import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
)

export default {
  name: 'invoices-received-list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    RejectInvoiceDialog,
    KendoGridComponent,
    InvoiceLinkGroupsDialog,
    Dialog,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 41,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Reject Invoice
      rejectDialog: false,
      // Link grupos
      showModalLinkGroups: false,
      showModalUnlinkGroups: false,
      showModalLinkGroupsReasig: false,
      // All
      multipleFilters: TIPOS_FILTER_MULTIPLE,
      estadosPorAccion: [],
      loader: false,
      spanish: true,
      nextStatus: null,
      header: {
        title: i18n.t('invoices.received_header'),
        icon: 'recived',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'invoicesReceived',
      hasClientFilterData: false,
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAccionesCliente: [
        { IdAccion: 102, Descripcion: i18n.t('groups.reasig') },
        { IdAccion: 100, Descripcion: i18n.t('groups.link_groups') },
      ],
      listaAccionesComunes: [
        { IdAccion: 101, Descripcion: i18n.t('groups.unlink_groups') }
      ],
      status: null,
      showModal: false,
      showModalDelete: false,
      processMessage: i18n.t('invoices.dialogs.send_invoice_header'),
      processMessageDelete: i18n.t('invoices.dialogs.send_invoice_header'),
      processMessageUnlinkGroups: i18n.t('app.unlink_all_entity_confirmation_f', { entity: i18n.t('groups.header').toLowerCase(), from: i18n.t('invoices.header').toLowerCase() }),
      selectedAction: null,
      invoicesActions: null,
      isNotice: false,
      noticeType: '',
    }
  },
  computed: {
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterRNav']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isMoreActionsVisible: function () {
      return this.accionesGeneral !== undefined && this.accionesGeneral.length > 0
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.kendo.dataResult ? this.kendo.dataResult.data.length : 0
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      var tags = this.$store.getters[this.vuexnamespace + '/getTags']
      if (this.status !== undefined && this.status !== 99999) {
        tags = tags.filter(x => x[0] !== 'estadoExtraRecibidas')
        if (this.status !== 17) {
          tags = tags.filter(x => !['fechaRechazoDesde', 'fechaRechazoHasta', 'motivoRechazo'].includes(x[0]))
        }
        if (this.status !== 18) {
          tags = tags.filter(x => !['fechaPagoDesde', 'fechaPagoHasta'].includes(x[0]))
        }
      }
      return tags
      // return this.status === undefined || this.status === 99999 ? tags : tags.filter(x => x[0] !== 'estadoExtra')
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    selectIcon: function () {
      return (IdAccion) =>
        IdAccion === 3 ? 'trash'
          : IdAccion === 100 ? 'groupadd' // Manual
            : IdAccion === 101 ? 'groupremove' // Manual
              : IdAccion === 102 ? 'groupchange' // Manual
                : IdAccion === 200 ? 'download'
                  : 'changestatus'
    },
    firstInvoiceSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) return { idFacturae: this.selected[0].idFacturae, idInvoice: this.selected[0].idInvoice }
      return 0
    },
    firstIdFacturae () {
      return this.firstInvoiceSelected?.idFacturae
    },
    firstIdInvoice () {
      return this.firstInvoiceSelected?.idInvoice
    },
    prevRoutePath () { return this.prevRoute ? this.prevRoute.path : '/' },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isInvoicesGeneral: function () {
      return (this.status === undefined || this.status === 99999) && (this.noticeType === '' || this.noticeType === undefined)
    },
    // Genera las acciones posibles comunes de los elementos seleccionados
    accionesBySelected: function () {
      const objAcciones = { Acciones: [] }
      if (this.selected.length > 0) {
        this.estadosPorAccion.forEach(estadoPorAccion => {
          if (this.selected.length === this.selected.filter(x => estadoPorAccion.estados.includes(x.idEstado)).length) {
            objAcciones.Acciones.push({ Descripcion: estadoPorAccion.Descripcion, IdAccion: estadoPorAccion.IdAccion })
          }
        })
        if (!this.hasIERPModule) {
          objAcciones.Acciones = objAcciones.Acciones.filter(tAction => !this.tiposAccion.filter(module => module.Modulo.includes(2)).map(map => map.id).includes(tAction.IdAccion))
        }
      }
      return objAcciones
    },
    userHasAllPermActions () {
      return [3, 8].includes(this.role) || this.userHasPoolGroup
    },
    // Generacion general de acciones
    accionesGeneral: function () {
      let acciones = []

      if (this.userHasAllPermActions || this.hasAllPropietariosByGroups(this.selected)) {
        // Si hay seleccion:
        if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
          // Comprobamos mismo cliente para añadir acciones comunes de cliente
          const idCliente = this.selected[0].idCliente
          if (this.selected.length === this.selected.filter(x => x.idCliente === idCliente).length) {
            // Añadimos las acciones comunes de cliente
            if (!this.isRoleUserOrConsulta) acciones = this.listaAccionesCliente
          }
          // Añadimos las acciones estaticas
          if (!this.isRoleUserOrConsulta) acciones = acciones.concat(this.listaAccionesComunes)
        }

        // Si no es consulta añadimos las acciones => Vista general: por seleccion, Vista de estado: por estado
        if (this.role !== 4) {
          if (this.isInvoicesGeneral) {
            acciones = acciones.concat(this.accionesBySelected.Acciones)
          } else {
            if (this.invoicesActions !== null && this.invoicesActions !== undefined) {
              acciones = acciones.concat(this.invoicesActions.Acciones)
            }
          }
        }
      } else {
        acciones = []
      }

      // Accion descarga local de adjuntos (para todos incluido Consulta)
      // if (this.selected.length === this.selected.filter(x => x.idEstado === 2 || x.idEstado === 7 || x.idEstado === 10 || x.idEstado === 11).length) acciones.push({ Descripcion: 'Descargar documentos', IdAccion: 200 })

      // Eliminamos borrar para rol Usuario y Consulta
      if (this.isRoleUserOrConsulta) acciones = acciones.filter(x => x.IdAccion !== 3)
      return acciones
    },
    hasAprobationFlowModule: function () {
      return this.$store.getters['auth/hasAprobationFlowModule']
    },
    hasIERPModule: function () {
      return this.$store.getters['auth/hasERPIntegrationModule']
    },
    iocrStates: function () {
      return this.tiposEstado.filter(x => x.Modulo.includes(1)).map(x => x.id)
    },
    ierpStates: function () {
      return this.tiposEstado.filter(x => x.Modulo.includes(2)).map(x => x.id)
    },
    userGroups: function () {
      return this.$store.getters['auth/user']?.Grupos
    },
    tiposEstado: function () {
      return this.$store.getters['config/TIPOS_ESTADO_RECEPCION']
    },
    tiposAccion: function () {
      return this.$store.getters['config/TIPOS_ACCION']
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE_RECEPCION']
    },
    invoiceClassTypes: function () {
      return this.$store.getters['config/TIPOS_INVOICE_CLASS']
    }
  },
  watch: {
    // $route: 'routerChangeHandler',
    $route (to, from) {
      this.checkIsNotice(to, from)
      this.updateOnRouteChange(to, from)
      this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    actualFilterNav: async function () {
      if (this.actualFilterNav === null || this.actualFilterNav === undefined || this.actualFilterNav === '') {
        await this.removeAllTagsHandler()
      }
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      const localGroups = dataState.group || []
      const localData = val || []
      if (localData.length && localGroups.length) {
        localData.forEach(x => {
          localGroups.forEach(group => {
            if (!hasNestedValue(group.field, x, { checkNull: true, checkUndefined: true })) {
              setNestedValue(group.field, x, '')
            }
          })
        })
      }
      this.kendo.dataResult = process(localData, dataState)
      this.unselect()
      // [TMP FIX] recargar data (Deja tiempo suficiente para esperar a getestadosdescarga)
      setTimeout(() => {
        this.routerChangeHandler()
      }, 1000)
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created: async function () {
    this.status = this.$route.meta.status
    this.$store.commit(this.vuexnamespace + '/setMenuType', this.status)

    if (this.$route.params.data) {
      this.filterByParamsData()
    }

    if (this.$route.meta && this.$route.meta.notice !== undefined && this.$route.meta.notice !== null) {
      this.isNotice = true
      this.noticeType = this.$route.meta.notice
      console.error(i18n.t('feedback.error.noticetype_not_found_error'))
    } else {
      this.isNotice = false
      this.noticeType = ''
      this.header.title = i18n.t('invoices.received_header')
    }
    // this.kendo = this.$store.getters[this.vuexnamespace + '/getKendo']
  },
  mounted: async function () {
    this.status = parseInt(this.$store.getters[this.vuexnamespace + '/getMenuType'])
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }

    if (this.status !== undefined && this.status !== 99999) {
      this.downloadInvoiceDataByStatus()
    } else {
      this.data = await this.applyFilters()
    }
    // await this.$store.dispatch('app/getInvoicesTypes')
  },
  methods: {
    filterStatesByModules (States) {
      if (!this.hasIERPModule) {
        States.Acciones = States.Acciones.filter(tAction => !this.tiposAccion.filter(module => module.Modulo.includes(2)).map(map => map.id).includes(tAction.IdAccion))
      }
      return States
    },
    hasAllPropietariosByGroups (invoices) {
      return invoices
        .every(x => this.userGroups
          .some(y => y.idGrupo === x.GrupoPropietario.idGrupo))
    },
    // Genera los estados por accion, de las acciones por estado
    generateEstadosPorAccion: function () {
      const estadosPorAccion = []
      this.invoicesActions.forEach(estadoAccion => {
        estadoAccion.Acciones.forEach(accion => {
          if (estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion).length === 0) {
            const accionTMP = accion
            accionTMP.estados = []
            estadosPorAccion.push(accionTMP)
          }
          if (!estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion)[0].estados.includes(estadoAccion.idEstado)) {
            estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion)[0].estados.push(estadoAccion.idEstado)
          }
        })
      })
      this.estadosPorAccion = estadosPorAccion
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    applyLinkHandler: async function (grupos) {
      this.showModalLinkGroups = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupos: [], idInvoiZEs: [] }
        payload.idGrupos = grupos
        payload.idInvoiZEs = this.selected.map(x => { return { idFacturae: x.idFacturae, idInvoice: x.idInvoice } })
        const response = await linkInvoiceGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
        this.data = await this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyLinkReasignHandler: async function (grupo) {
      this.showModalLinkGroupsReasig = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idInvoiZEs: [], idGrupo: grupo }
        payload.idInvoiZEs = this.selected.map(x => { return { idFacturae: x.idFacturae, idInvoice: x.idInvoice } })
        const response = await linkInvoicesGroupReasign(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_reasigned_msg'), 'success')
        }
        this.data = await this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDialogs: function () {
      if (this.showModalLinkGroups) return
      this.showModalLinkGroups = !this.showModalLinkGroups
    },
    toggleDialogReasign () {
      if (this.showModalLinkGroupsReasig) return
      this.showModalLinkGroupsReasig = !this.showModalLinkGroupsReasig
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'company') {
            const cif = { label: i18n.t('companies.companyName'), value: filter.data.label }
            filters.NombreCIF = cif
          } else if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id } }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    checkIsNotice: function (to, from) {
      if (to.meta && to.meta.notice !== undefined) {
        this.isNotice = true
        this.noticeType = to.meta.notice
        console.error(i18n.t('feedback.error.noticetype_not_found_error'))
      } else {
        this.isNotice = false
        this.noticeType = ''
        this.header.title = i18n.t('invoices.received_header')
      }
    },
    updateOnRouteChange: async function (to, from) {
      this.status = parseInt(to.meta.status)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setMenuType', this.status)
      // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      // this.$store.commit(this.vuexnamespace + '/resetPaginationInfo')
      if (to.meta && to.meta.status !== undefined && to.meta.status !== 99999) {
        this.downloadInvoiceDataByStatus()
      } else {
        this.data = await this.applyFilters()
      }
    },
    routerChangeHandler: function (to, from) {
      this.resetinvoicesActions()
      if (this.status !== undefined && this.status !== 99999) {
        this.invoicesActions = this.filterStatesByModules(this.$store.getters['app/actionsForSelect'](this.status, 'Recibida'))
      } else {
        this.resetinvoicesActions()
      }
    },
    resetinvoicesActions: function () {
      this.invoicesActions = this.$store.getters['app/actionsForSelect'](null, 'Recibida')
      this.generateEstadosPorAccion() // Necesario para logica automatica de compatibilidad de acciones
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.NumFactura)
      const status = this.status === 99999 ? event.dataItem.idEstado : this.status
      this.$router.push(
        {
          name: 'invoicesreceived/details',
          params: {
            // id: event.dataItem.IDInterno, 
            idFacturae: event.dataItem.idFacturae,
            idInvoice: event.dataItem.idInvoice,
            type: status,
            asunto: event.dataItem.NumFactura,
            notice: this.noticeType,
            fromGeneral: this.status === 99999 || this.status === '99999',
          }
        }
      )
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    getParamsFilter (data) {
      return {
        fechaFacturaDesde: data.fechaFacturaDesde ? data.fechaFacturaDesde.value : null,
        fechaFacturaHasta: data.fechaFacturaHasta ? data.fechaFacturaHasta.value : null,
        tipoInvoiceClass: data.tipoInvoiceClass ? data.tipoInvoiceClass.value : null,
        pge: data.PGE ? data.PGE.value : null,
        importeMinimo: data.importeDesde ? data.importeDesde.value : null,
        importeMaximo: data.importeHasta ? data.importeHasta.value : null,
        numFactura: data.numFactura ? data.numFactura.value : null,
        SerieFactura: data.SerieFactura ? data.SerieFactura.value : null,
        cifEmisor: data.cifEmisor ? data.cifEmisor.value : null,
        nombreCIFEmisor: data.NombreCIFEmisor ? data.NombreCIFEmisor.value : null,
        cifReceptor: data.cifReceptor ? data.cifReceptor.value : null,
        nombreCIFReceptor: data.NombreCIFReceptor ? data.NombreCIFReceptor.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value.idCliente : null,
        comentarios: data.notas ? data.notas.value : null,
        importe: data.importe ? data.importe.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
        ultimoError: data.ultimoError ? data.ultimoError.value : null,
        MotivoRechazo: data.motivoRechazo ? data.motivoRechazo.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        fechaPagoDesde: data.fechaPagoDesde ? data.fechaPagoDesde.value : null,
        fechaPagoHasta: data.fechaPagoHasta ? data.fechaPagoHasta.value : null,
        fechaRechazoDesde: data.fechaRechazoDesde ? data.fechaRechazoDesde.value : null,
        fechaRechazoHasta: data.fechaRechazoHasta ? data.fechaRechazoHasta.value : null,
        fechaEntradaERPDesde: data.fechaEntradaERPDesde ? data.fechaEntradaERPDesde.value : null,
        fechaEntradaERPHasta: data.fechaEntradaERPHasta ? data.fechaEntradaERPHasta.value : null,
        agrupacionCIF: data.agrupacionCIF ? data.agrupacionCIF.value : null,
        csv: data.csv ? data.csv.value : null,
        numAsiento: data.NumAsiento ? data.NumAsiento.value : null,
        recibidas: true,
        contieneAdjuntos: data.contieneAdjuntos ? data.contieneAdjuntos.value : null,
      }
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loader = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const orders = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = {
        order: orders.order,
        grupos: objColumnas,
      }

      // Filtros multiples casos especiales
      const estadosFilter = (this.status !== undefined && this.status !== 99999) ? this.status : data.estadoExtraRecibidas ? data.estadoExtraRecibidas.value : null
      if (Array.isArray(estadosFilter)) {
        payload.estadosFacturas = estadosFilter
      } else {
        params.estado = estadosFilter
        if ((this.status !== undefined && this.status !== 99999)) {
          if (estadosFilter !== 17) {
            params.fechaRechazoDesde = null
            params.fechaRechazoHasta = null
            params.MotivoRechazo = null
          }
          if (estadosFilter !== 18) {
            params.fechaPagoDesde = null
            params.fechaPagoHasta = null
          }
        }
      }
      // const sedesFilter = data.codPGN ? data.codPGN.value : null
      // if (Array.isArray(sedesFilter)) {
      //   payload.codPGNs = sedesFilter
      // } else {
      //   params.codPGN = sedesFilter
      // }

      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => {
          return {
            idFacturae: x.idFacturae,
            idInvoice: x.idInvoice,
          }
        })
        payload.listaIDs = selectedIDs
      }
      let response
      try {
        if (!this.isNotice) {
          response = await getInvoicesExcel(payload, params)
        }
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'facturas-recibidas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loader = false
      }
    },
    toBinary: function (string) {
      const codeUnits = new Uint16Array(string.length)
      for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = string.charCodeAt(i)
      }
      return String.fromCharCode(...new Uint8Array(codeUnits.buffer))
    },
    fromBinary: function (binary) {
      const bytes = new Uint8Array(binary.length)
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i)
      }
      return String.fromCharCode(...new Uint16Array(bytes.buffer))
    },
    onColumnsSubmit: function (columnsState) {
      const options = {
        columns: columnsState
      }
      this.columnReorder(options)
      // this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandchange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      // Filtros multiples casos especiales
      const estadosFilter = (this.status !== undefined && this.status !== 99999) ? this.status : data.estadoExtraRecibidas ? data.estadoExtraRecibidas.value : null
      if (Array.isArray(estadosFilter)) {
        obj.estadosFacturas = estadosFilter
      } else {
        params.estado = estadosFilter
        if ((this.status !== undefined && this.status !== 99999)) {
          if (estadosFilter !== 17) {
            params.fechaRechazoDesde = null
            params.fechaRechazoHasta = null
            params.MotivoRechazo = null
          }
          if (estadosFilter !== 18) {
            params.fechaPagoDesde = null
            params.fechaPagoHasta = null
          }
        }
      }
      if (data.metadatos?.value?.length) {
        obj.metadatos = data.metadatos?.value
      }

      // const sedesFilter = data.codPGN ? data.codPGN.value : null
      // if (Array.isArray(sedesFilter)) {
      //   obj.codPGNs = sedesFilter
      // } else {
      //   params.codPGN = sedesFilter
      // }
      try {
        const data = await this.getItemsData(obj, params)
        return data/* .map(item => {
          item.selected = false
          item.PgeKey = item.Pge
          item.Pge = this.pgeTypes.filter(x => x.id === item.Pge)[0]?.name ?? item.Pge
          item.Estado = this.tiposEstado.find(x => x.id === item.idEstado)?.Nombre ?? item.Estado
          item.TipoInvoiceClass = this.invoiceClassTypes.find(x => x.id === item.CorrectionMethod)?.Nombre ?? item.TipoInvoiceClass
          return item
        }) */
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      this.updateAllSelectedHeader()
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.respuesta

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getInvoices(orders, params)
      if (data.blnError === true) {
        this.doFeedback(`${data.msgError} [${data.codError}]`)
      }
      data.respuesta.forEach(o => {
        // o.FechaFactura = moment(o.FechaFactura).format('DD-MM-YYYY HH:mm')
      })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const index = tag.at(-1)
      const tagName = this.multipleFilters.find(x => new RegExp('^' + x.NombreTag + '\\d*$').test(tag[0]))?.NombreTag
      if (tagName) {
        if (Number.isInteger(index) && Array.isArray(filter[tagName].value) && index > -1 && 
          index < filter[tagName]?.value.length && filter[tagName]?.value.length > 1) {
          filter[tagName].value.splice(index, 1)
        } else {
          delete filter[tagName]
        }
      } else {
        delete filter[tag[0]]
      }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    headerCoreFiltersHandler: async function (obs) {
      if (this.isHeadCoreReady) {
        this.data = await this.applyFilters()
      }
    },
    removeAllTagsHandler: async function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    tableSortByChangeHandler: async function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters()
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    download: async function () {
      this.showModal = !this.showModal
    },
    deleteNotification: async function () {
      this.showModalDelete = !this.showModalDelete
    },
    downloadHandler: async function () {
      this.executeActionHandler()
    },
    deleteHandler: async function () {
      this.executeActionHandler()
    },
    goLinkLocation: function () {
      this.linkLocation = !this.linkLocation
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    goToNewLocation: function () {
      //
    },
    unlinkGroups: async function () {
      this.showModalUnlinkGroups = !this.showModalUnlinkGroups
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 1) { // enviar
        this.showModal = true
      } else if (this.selectedAction.IdAccion === 3) { // borrar
        this.showModalDelete = true
      } else if (this.selectedAction.IdAccion === 15) { // Rechazo de Factura Recibida
        this.toggleRejectDialog()
      } else if (this.selectedAction.IdAccion === 100) { // vincular grupos
        this.toggleDialogs()
      } else if (this.selectedAction.IdAccion === 101) { // desvincular grupos
        this.unlinkGroups()
      } else if (this.selectedAction.IdAccion === 102) { // Reasignar propietario a grupo
        this.toggleDialogReasign()
      } else {
        this.executeActionHandler()
      }
    },
    executeActionHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)

        const selected = this.selected
        const idAccion = this.selectedAction.IdAccion
        const data = {
          idAccion,
          facturasCambio: [],
        }
        selected.forEach(x => {
          data.facturasCambio.push({
            IdInvoice: x.idInvoice,
            IdFacturae: x.idFacturae,
            Estado: x.idEstado,
          })
        })

        const response = await actualizarEstadoAccion(data)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.downloadInvoiceDataByStatus()
        bus.$emit('changeIt', 'changed menu')
      }
    },
    downloadInvoiceDataByStatus: async function () {
      // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      try {
        const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
        filter.estado = { label: 'Estado', value: this.status }

        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
        this.invoicesActions = this.$store.getters['app/actionsForSelect'](this.status, 'Recibida')
        if (this.status !== undefined && this.status !== 99999) {
          this.header.title = this.invoicesActions.InfoAdicional
          this.invoicesActions = this.filterStatesByModules(this.$store.getters['app/actionsForSelect'](this.status, 'Recibida'))
        }
        this.data = await this.applyFilters()
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    unlinkGroupsHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push({ idFacturae: element.idFacturae, idInvoice: element.idInvoice })
        }
        const response = await unlinkInvoiceGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
    showAction: function (action) {
      return !(action.IdAccion === 12 && this.rowsSelected !== 1)
    },
    toggleRejectDialog: function () {
      this.rejectDialog = !this.rejectDialog
    },
    applyRejectDialog: async function (data) {
      this.toggleRejectDialog()
      // Realizar rechazo en API de GestionFacturas
      this.executeRejectHandler(data)
    },
    executeRejectHandler: async function (rejectMessage = { idMensaje: -1, mensaje: '', fechaMensaje: Date.now() }) {
      try {
        this.$store.commit('setIsLoading', true)

        const selected = this.selected
        const idAccion = this.selectedAction.IdAccion
        rejectMessage.mensaje = rejectMessage.mensaje.trim()

        if (idAccion !== 15) {
          this.doFeedback(i18n.t('feedback.error.action_must_be_error', { action: i18n.t('configurations.reject_invoice') }))
          return
        }
        if (!rejectMessage.mensaje && rejectMessage.mensaje === '') {
          this.doFeedback(i18n.t('feedback.error.obligatory_field_error', { field: i18n.t('configurations.reject_msgs').toLowerCase() }))
          return
        }

        const data = {
          idAccion,
          facturasCambio: [],
          // rejectMessage,
          // TODO - Enviar objeto de mensaje para mensajes recientes
          mensaje: rejectMessage.mensaje,
        }
        selected.forEach(x => {
          data.facturasCambio.push({
            IdInvoice: x.idInvoice,
            IdFacturae: x.idFacturae,
            Estado: x.idEstado,
          })
        })

        const response = await actualizarEstadoAccion(data)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.downloadInvoiceDataByStatus()
        bus.$emit('changeIt', 'changed menu')
      }
    },
  }
}
</script>

<style lang='scss' scoped></style>
